import {makeObservable, observable, action, runInAction} from "mobx"


export class SessionState {
    isLoggedIn = null
    user = null

    constructor() {
        makeObservable(this, {
            isLoggedIn: observable,
            setLoggedIn: action,
        })
        this.checkIsLoggedIn().then();
    }

    async checkIsLoggedIn() {
        console.log("checkIsLoggedIn")

        if (typeof window === 'undefined') {
            return;
        }

        let data = sessionStorage.getItem('user');

        if (data) {
            this.user = JSON.parse(data);
            this.setLoggedIn(true);
            return;
        }


        let response = await fetch('/api/auth/session')
        let session = await response.json()
        this.user = session?.user;

        if (this.user) {
            this.startUserTracking();
            console.log("checkIsLoggedIn", session)
            this.setLoggedIn(true);
        } else {
            console.log("checkIsLoggedIn", false)
            this.setLoggedIn(false);
        }
    }

    startUserTracking() {
        if (typeof window === 'undefined') return;
        sessionStorage.setItem('user', JSON.stringify(this.user));
        window?._paq?.push(['setUserId', `${this.user.email}`]);
        window?._paq?.push(['setCustomDimension', 1, `${this.user.name}`]);
    }

    resetUserTracking() {
        if (typeof window === 'undefined') return;
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('searchInput');
        window?._paq?.push(['resetUserId']);
    }

    setLoggedIn(value) {
        console.log("setLoggedIn", value)
        if (value === false) {
            this.resetUserTracking();
        }
        this.isLoggedIn = value
    }

    setUserInfo(user) {
        console.log("setUserInfo", user)
        this.user = user
    }

    setSession(session) {
        console.log("setSession", session)
        this.session = session
    }
}

let sessionState = new SessionState()

export default sessionState